const Mixin = {
  methods: {
    /**
     * Redirect argument url
     */
    redirect(url) {
      window.location.href = url
    },

    /**
     * Reload url
     */
    reload() {
      window.location.reload()
    },
  },
}

export default Mixin
